import { IFilters } from '../../types/filters';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EFiltersActionType, TMergeFilters, TReplaceSavedFilters, TSetSavedFilters } from './types';

export const setSavedFilters: (savedFilters: Partial<IFilters>) => TSetSavedFilters = actionGenerator<
  EFiltersActionType.SetSavedFilters,
  Partial<IFilters>
>(EFiltersActionType.SetSavedFilters);

export const replaceSavedFilters: (savedFilters: IFilters) => TReplaceSavedFilters = actionGenerator<
  EFiltersActionType.ReplaceSavedFilters,
  IFilters
>(EFiltersActionType.ReplaceSavedFilters);

export const mergeFilters: () => TMergeFilters = actionGenerator<EFiltersActionType.MergeFilters>(
  EFiltersActionType.MergeFilters,
);
